
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import api from "../../../services/api";

const CustomDropdown = ({
  rowId,
  placeholder,
  selectedValue,
  onChange,
  column,
  openDropdown,
  setOpenDropdown,
  ledgerData,
  allPaymentData,
  setFetchDatabyFilter,
  defaultLedgerGroup = '',
  onCreateLedgerFromDropdown = null,
  setDropDownOpen,
  dropDownOpen,
  setUniqueFilter,
  setAddFilterationValue,
  uniqueForFilter,
  onAddNewPayment = null,
  rowData = null,
  showValidationError = null,
  externalGroupIds = [],
  externalSubGroupIds = [],
  hasExternalFilter = false,

}) => {
  const wrapperRef = useRef(null);
  const optionRefs = useRef([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isOpen =
    openDropdown &&
    openDropdown.rowId === rowId &&
    openDropdown.placeholder === placeholder;

  const [highlightIndex, setHighlightIndex] = useState(-1);
  const justOpenedByClickRef = useRef(false);

const dropdownOptions = useMemo(() => {
  let filteredLedgerData = ledgerData || [];

  if (column.placeholder === "typeOfBricks" || column.placeholder === "items") {
    filteredLedgerData = filteredLedgerData.filter(
      (ldg) => ldg.groupType === "Stock"
    );
  }

  // if (hasExternalFilter) {
  //   if (externalGroupIds.length === 0 && externalSubGroupIds.length === 0) {
  //     filteredLedgerData = [];
  //   } else {
  //     filteredLedgerData = filteredLedgerData.filter(ldg => {
  //       const matchesGroup = externalGroupIds.includes(ldg.groupId || ldg.group_id);
  //       const matchesSub = externalSubGroupIds.includes(ldg.subGroupId || ldg.sub_group_id);
  //       return matchesGroup || matchesSub;
  //     });
  //   }
  // }
  // In CustomDropdown.jsx, inside dropdownOptions useMemo:
if (hasExternalFilter) {
  if (externalGroupIds.length === 0 && externalSubGroupIds.length === 0) {
    filteredLedgerData = [];
  } else {
    filteredLedgerData = filteredLedgerData.filter(ldg => {
      // Handle both camelCase and snake_case
      const ldgGroupId = ldg.groupId ?? ldg.group_id;
      const ldgSubGroupId = ldg.subGroupId ?? ldg.sub_group_id;
      const matchesGroup = externalGroupIds.includes(ldgGroupId);
      const matchesSub = externalSubGroupIds.includes(ldgSubGroupId);
      return matchesGroup || matchesSub;
    });
  }
}

  //  THESE WERE MISSING — must come AFTER the filter block
  if (Array.isArray(column.options) && column.options.length > 0) {
    return column.options;
  }

  if (column.addDropDownOptions && allPaymentData) {
    const seen = new Set();
    return allPaymentData
      ?.map((ldg) => ({
        id: ldg?.ledgerId,
        name: ldg?.name || ldg?.[placeholder] || "",
      }))
      .filter((opt) => {
        if (!opt.name || seen.has(opt.name)) return false;
        seen.add(opt.name);
        return true;
      });
  }

  const seen = new Set();
  return filteredLedgerData
    .map((ldg) => ({
      id: ldg?.id,
      name: ldg?.name || ldg?.[placeholder] || "",
    }))
    .filter((opt) => {
      if (!opt.name || seen.has(opt.name)) return false;
      seen.add(opt.name);
      return true;
    });
}, [
  column,
  ledgerData,
  placeholder,
  allPaymentData,
  externalGroupIds,
  externalSubGroupIds,
  hasExternalFilter,
]);
  const addNewIndex = dropdownOptions.length;
  // Total items in keyboard navigation
  const totalOptions = column.removeAddBtn
    ? dropdownOptions.length
    : dropdownOptions.length + 1; // +1 for "Add New"

  /* -------------------- SELECT HANDLER -------------------- */

  const handleSelect = useCallback(
    (selected) => {
      if (selected?.__type === "CREATE_LEDGER") {
        if (column.addDropDownOptions) {
          if (typeof onAddNewPayment === 'function') {
            onAddNewPayment();
          }
          setOpenDropdown(null);
          return;
        }

        const ledgerData = {
          name: '',
          group: selected.group || defaultLedgerGroup,
          placeholder: placeholder,
          phone: '',
          address: '',
        };

        if (typeof onCreateLedgerFromDropdown === 'function') {
          onCreateLedgerFromDropdown(ledgerData);
        }

        setOpenDropdown(null);
        return;
      }

      const fullLedger =ledgerData && ledgerData.find(
        l => l.id === selected.id || l.name === selected.name
      );

      const enrichedSelected = fullLedger
        ? {
            ...selected,
            unitId: fullLedger.unitId,
            unit: fullLedger.unitName,
            perQuantity: fullLedger.perQuantity,
          }
        : selected;

      onChange(enrichedSelected);
      setOpenDropdown(null);

      setTimeout(() => {
        const currentCell = document
          .querySelector(`[data-row-id="${rowId}"][data-placeholder="${placeholder}"]`)
          ?.closest('td');

        if (currentCell) {
          const row = currentCell.closest('tr');
          const cells = Array.from(row.querySelectorAll('td'));
          const currentIndex = cells.indexOf(currentCell);
          const nextCell = cells[currentIndex + 1];

          if (nextCell) {
            const nextInput = nextCell.querySelector('input');
            const nextDropdown = nextCell.querySelector('[data-dropdown]');

            if (nextDropdown) {
              const nextPlaceholder = nextDropdown.getAttribute('data-placeholder');
              nextDropdown.focus();
              setTimeout(() => {
                setOpenDropdown({ rowId, placeholder: nextPlaceholder });
              }, 10);
            } else if (nextInput) {
              nextInput.focus();
            }
          }
        }
      }, 50);
    },
    [
      onChange,
      setOpenDropdown,
      onCreateLedgerFromDropdown,
      defaultLedgerGroup,
      placeholder,
      ledgerData,
      column.addDropDownOptions,
      rowId,
      onAddNewPayment
    ]
  );

  /* -------------------- KEYBOARD HANDLING -------------------- */

  const handleKeyDown = (e) => {
    if (!isOpen) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setOpenDropdown({ rowId, placeholder });
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        const currentCell = document
          .querySelector(`[data-row-id="${rowId}"][data-placeholder="${placeholder}"]`)
          ?.closest('td');

        if (currentCell) {
          const row = currentCell.closest('tr');
          const cells = Array.from(row.querySelectorAll('td'));
          const currentIndex = cells.indexOf(currentCell);
          const nextCell = cells[currentIndex + 1];

          if (nextCell) {
            const nextInput = nextCell.querySelector('input');
            const nextDropdown = nextCell.querySelector('[data-dropdown]');

            if (nextDropdown) {
              nextDropdown.focus();
            } else if (nextInput) {
              nextInput.focus();
            }
          } else {
            const currentTable = currentCell.closest('table');
            const allTables = Array.from(document.querySelectorAll('table'));
            const currentTableIndex = allTables.indexOf(currentTable);
            const nextTable = allTables[currentTableIndex + 1];

            if (nextTable) {
              const firstInput = nextTable.querySelector('input, [data-dropdown]');
              if (firstInput) {
                firstInput.focus();
                if (firstInput.hasAttribute('data-dropdown')) {
                  const rowId = firstInput.getAttribute('data-row-id');
                  const placeholder = firstInput.getAttribute('data-placeholder');
                  setTimeout(() => setOpenDropdown({ rowId, placeholder }), 10);
                }
              }
            } else {
              const saveButton = document.querySelector('.save-button');
              if (
                saveButton &&
                (saveButton.textContent.toLowerCase().includes('save') ||
                  saveButton.textContent.includes('सेव'))
              ) {
                saveButton.focus();
                setTimeout(() => {
                  saveButton.click();
                }, 100);
              }
            }
          }
        }
        return;
      }

      if (e.key === "Tab") {
        return;
      }
      return;
    }

    // ── Dropdown is OPEN ──────────────────────────────────────────

    if (e.key === "Tab") {
      setOpenDropdown(null);
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((prev) => {
        if (prev === -1 || prev === addNewIndex) return 0;
        const lastRealIndex = dropdownOptions.length - 1;
        return prev < lastRealIndex ? prev + 1 : prev;
      });
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) => {
        if (prev === addNewIndex) return addNewIndex;
        if (prev <= 0) return addNewIndex;
        return prev - 1;
      });
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      const effectiveIndex = highlightIndex >= 0 ? highlightIndex : 0;

      if (!column.removeAddBtn && effectiveIndex === addNewIndex) {
        handleSelect({ __type: "CREATE_LEDGER", group: defaultLedgerGroup });
      } else if (dropdownOptions[effectiveIndex]) {
        handleSelect(dropdownOptions[effectiveIndex]);
      }
      return;
    }

    if (e.key === "Escape") {
      e.preventDefault();
      setOpenDropdown(null);
      setHighlightIndex(-1);

      const currentCell = document
        .querySelector(`[data-row-id="${rowId}"][data-placeholder="${placeholder}"]`)
        ?.closest('td');
      if (currentCell) {
        const row = currentCell.closest('tr');
        const cells = Array.from(row.querySelectorAll('td'));
        const currentIndex = cells.indexOf(currentCell);
        const prevCell = cells[currentIndex - 1];
        if (prevCell) {
          const prevInput = prevCell.querySelector('input');
          if (prevInput) prevInput.focus();
        }
      }
      return;
    }
  };

  /* -------------------- EFFECTS -------------------- */

  // Scroll highlighted option into view
  useEffect(() => {
    if (isOpen && highlightIndex >= 0 && optionRefs.current[highlightIndex]) {
      optionRefs.current[highlightIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightIndex, isOpen]);

  useEffect(() => {
    if (isOpen) {
      setHighlightIndex(0);
    } else {
      setHighlightIndex(-1);
    }
  }, [isOpen]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [setOpenDropdown]);

  const skipValidationFields = [
    'typeOfBricks',
    'items',
    'customerName',
    'name',
    'vendor',
    'paymentType',
    'itemInOut',
  ];

  return (
    <div
      ref={wrapperRef}
      className="relative w-full text-start"
      onKeyDown={handleKeyDown}
      data-row-id={rowId}
      data-placeholder={placeholder}
    >
      <div
        className={`w-full border bg-theme-tableBg px-2 cursor-pointer select-none overflow-hidden text-nowrap capitalize ${
          !selectedValue ||
          (typeof selectedValue === "string" &&
            (selectedValue.toLowerCase() === "select" ||
              selectedValue.toLowerCase() === "select type"))
            ? "text-gray-400 "
            : "text-gray-700"
        }`}
        onClick={(e) => {
          e.stopPropagation();

          setAddFilterationValue(true);

          if (column.filteration) {
            setUniqueFilter(
              column.inputType === "input" ? "text_type" : "dropdown_type"
            );
          }
          const willOpen = !isOpen;
          setDropDownOpen(willOpen);
          setOpenDropdown(willOpen ? { rowId, placeholder } : null);

          if (setFetchDatabyFilter && willOpen) {
            setFetchDatabyFilter(column.header);
          }
        }}
        onFocus={(e) => {
 
          if (!skipValidationFields.includes(placeholder)) {
            const typeOfBricksValue = rowData?.typeOfBricks || rowData?.items;
            if (!typeOfBricksValue) {
              if (showValidationError) {
                showValidationError('Please select Item/Type of Bricks first');
              }
              return;
            }
          }

          setAddFilterationValue(true);
          if (setFetchDatabyFilter) {
            setFetchDatabyFilter(column.header);
            if (column.filteration) {
              setUniqueFilter(column.inputType === "input" ? "text_type" : "dropdown_type");
            }
          }
        }}
        data-dropdown
        data-placeholder={placeholder}
        tabIndex={0}
      >
        {selectedValue
          ? typeof selectedValue === "object"
            ? selectedValue.name || selectedValue[placeholder] || selectedValue.id
            : selectedValue
          : `${Array.isArray(column.options) && column.options.length > 0 ? "select" : "select type"} `}
      </div>

      {isOpen && (
        <ul
          className="absolute z-50 bg-theme-sidebarTabBg border border-gray-300 rounded mt-1 min-w-[200px] xl:min-w-[150px] shadow p-0"
          style={{ maxHeight: "250px", overflowY: "auto", scrollbarWidth: "thin" }}
        >
          {/* "Add New" button — sticky top, keyboard mein LAST index (addNewIndex) */}
          {!column.removeAddBtn && (
            <li
              ref={(el) => (optionRefs.current[addNewIndex] = el)}
              className={`py-1 text-sm cursor-pointer font-semibold border-b border-gray-300 text-center sticky top-0 z-10 ${
                highlightIndex === addNewIndex
                  ? "bg-theme-dropdownHeqadibg text-theme-color"
                  : "bg-theme-sidebarTabBg text-theme-dropdownHeqadibg hover:bg-theme-dropdownHeqadibg hover:text-theme-sidebarTabBg"
              }`}
              onMouseEnter={() => setHighlightIndex(addNewIndex)}
              onMouseLeave={() => setHighlightIndex(-1)}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect({ __type: "CREATE_LEDGER", group: defaultLedgerGroup });
              }}
            >
              + {t("addNew")}
            </li>
          )}

          {dropdownOptions.map((opt, i) => (
            <li
              key={i}
              ref={(el) => (optionRefs.current[i] = el)}
              className={`w-full py-1 px-2 cursor-pointer capitalize overflow-hidden ${
                i === highlightIndex
                  ? "bg-theme-dropdownHeqadibg text-theme-color"
                  : "hover:text-black hover:bg-theme-tableHoverColor"
              }`}
              onMouseEnter={() => setHighlightIndex(i)}
              onMouseLeave={() => setHighlightIndex(-1)}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(opt);
              }}
            >
              {Array.isArray(column.options) && column.options.length > 0 ? opt : opt.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;